import { render, staticRenderFns } from "./TextField_old.vue?vue&type=template&id=38ca699a"
import script from "./TextField_old.vue?vue&type=script&lang=js"
export * from "./TextField_old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ca699a')) {
      api.createRecord('38ca699a', component.options)
    } else {
      api.reload('38ca699a', component.options)
    }
    module.hot.accept("./TextField_old.vue?vue&type=template&id=38ca699a", function () {
      api.rerender('38ca699a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/TextField_old.vue"
export default component.exports